import React, { ReactElement } from 'react';
import { Layout } from 'antd';
import GuestMenu from '../Components/GuestMenu';
const { Sider, Footer } = Layout;

class GuestApp extends React.Component<{
  children: React.ReactNode;
}> {
  state = {
    collapsed: false,
    collapsedWidth: undefined,
  };

  onCollapse = (collapsed: boolean): void => {
    this.setState({ collapsed });
  };

  render(): ReactElement {
    const { children } = this.props;
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Sider
          collapsible
          breakpoint="lg"
          collapsedWidth={this.state.collapsedWidth}
          onBreakpoint={(broken: boolean): void => {
            if (broken) {
              this.setState({
                collapsedWidth: '0',
              });
            } else {
              this.setState({
                collapsedWidth: undefined,
              });
            }
          }}
          collapsed={this.state.collapsed}
          onCollapse={this.onCollapse}
        >
          <div className="logo">
            <img src={require('../assets/edari.png')} style={{ maxWidth: '60%', marginLeft: '20px' }} />
          </div>
          <GuestMenu />
        </Sider>
        <Layout style={{ padding: '0 24px 24px' }}>
          {children}
          <Footer style={{ textAlign: 'center' }}>Edari ©{new Date().getFullYear()}</Footer>
        </Layout>
      </Layout>
    );
  }
}

export default GuestApp;
